<template>
  <el-table
    ref="table"
    class="table"
    :data="list"
    @selection-change="handleSelectionChange"
    style="width: 100%"
    border>
    <el-table-column
      v-if="selection"
      type="selection"
      :selectable="selectable"
      width="80"
      fixed
      align="center">
    </el-table-column>
    <el-table-column
      label="序号"
      type="index"
      fixed
      align="center"
      width="100">
    </el-table-column>
    <el-table-column
      v-for="(item, index) in fieldList"
      v-bind:key="index"
      :prop="item.prop"
      :label="item.label"
      :fixed="item.fixed ? item.fixed : false"
      :width="item.width"
      align="center">
      <template slot-scope="scope">
        <slot v-if="item.type === 'slot'"
              :name="'col-' + item.prop"
              :row="scope.row"
              :index="scope.$index"/>
        <img :src="scope.row[item.prop].attachUrl" alt=""
              v-else-if="item.type === 'img' && scope.row[item.prop]" class="icon">
        <span v-else-if="item.type === 'img' && !scope.row[item.prop]">无</span>
        <span v-else>
          {{scope.row[item.prop] ? scope.row[item.prop] : '-'}}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="btns.indexOf('handle') !== -1"
      fixed="right"
      label="操作"
      :width="handelWidth"
      align="center">
      <template slot-scope="scope">
        <el-row :guttar="12" type="flex" justify="space-around">
          <el-col v-if="handleSlot" style="display: flex; align-items: center;">
            <slot name="handleSlot" :row="scope.row"
                  :index="scope.$index"/>
          </el-col>
          <el-col :span="3" v-if="btns.indexOf('edit') !== -1">
            <el-button type="text" @click="edit(scope.$index, scope.row)" :disabled="$has(permission + 'Edit')"><i class="el-icon-edit-outline"></i></el-button>
          </el-col>
          <el-col :span="3"  v-if="btns.indexOf('copy') !== -1">
            <el-button type="text" @click="add(scope.$index, scope.row)"
                        :disabled="$has(permission + 'Add')"><i class="el-icon-document-copy"></i></el-button>
          </el-col>
          <el-col :span="3" v-if="btns.indexOf('delet') !== -1">
            <el-button type="text" @click="delet(scope.$index, scope.row)"
                        :disabled="$has(permission + 'Delete')"><i class="el-icon-delete"></i></el-button>
          </el-col>
          <el-col :span="3" v-if="btns.indexOf('view') !== -1">
            <el-button type="text" @click="view(scope.$index, scope.row)"
                        :disabled="$has(permission + 'View')"><i class="el-icon-view"></i></el-button>
          </el-col>
        </el-row>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: 'tablelist',
  // 传值参数
  props: {
    // 功能
    btns: {
      type: Array,
      default: () => {
        return []
      }
    },
    deleteName: {
      type: String
    },
    // 是否多选
    selection: {
      type: Boolean
    },
    /**
     * selection 是否可以勾选
     */
    selectable: {
      type: Function
    },
    /*
    * 列表
    * */
    list: {
      type: Object | Array
    },
    /*
    * 表头
    * */
    fieldList: {
      type: Array
    },
    /*
    * 选择
    * */
    selectionChange: {
      type: Function,
      default: null
    }
  }, // 接收父组件的方法
  data () {
    return {
      multipleSelection: []
    }
  },
  components: {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val.map(ele => {
        return ele[this.deleteName]
      })
      if (this.selectionChange) {
        this.selectionChange(val)
      }
    }
  }
}
</script>

<style scope>

</style>



// WEBPACK FOOTER //
// src/page/costMenu/components/Table.vue